import { getLocalization } from 'global/global';
import { useAppSelector } from 'index';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import * as React from 'react';
import { Table } from 'react-bootstrap';
import { uniqueFormsSelector } from 'reducers/formsReducer';
import FormUtils from 'views/SingleInstance/utils/FormUtils';
import { getFormUtils } from 'views/SingleInstance/utils/FormUtilsHolder';

interface Props {
  questionIds: string[];
  columns: string[];
  values: string[][];
  formId: string;
}

export default function ImportPreview(props: Props) {
  const { questionIds, columns, values, formId } = props;
  const forms: FormInterface[] = useAppSelector(state => uniqueFormsSelector(state));
  const clientPersist = useAppSelector(state => state.clientPersist);
  const [formUtils, setFormUtils] = React.useState<FormUtils | null>(null);
  React.useEffect(() => {
    const tempForm = forms.find(f => f.ref === formId);
    if (tempForm) {
      setFormUtils(getFormUtils(tempForm));
    } else {
      setFormUtils(null);
    }
  }, [formId]);

  const getMissingQuestionText = (questionId: string) => {
    if (questionId && questionId.startsWith('location')) {
      const index = questionId.substring(8);
      return clientPersist.locationLabels[Number(index) - 1] || '';
    }
    return '';
  };

  return formUtils ? (
    <div className="import-questions">
      <h5>{getLocalization('previewImport')}</h5>
      <Table striped={true}>
        <thead>
          <tr>
            <th>{getLocalization('csvColumn')}</th>
            <th>{getLocalization('formFields')}</th>
            <th>{getLocalization('csvValues')}</th>
          </tr>
        </thead>
        <tbody>
          {columns.map((c, index) => {
            const question = formUtils?.getQuestion(questionIds[index]);
            const text = question ? question.text : getMissingQuestionText(questionIds[index]);
            return (
              <tr key={`preview-${c}-${index}-${question?.id}`}>
                <td>{c}</td>
                <td>{text}</td>
                <td>{values.map((v) => v[index]).join(',')}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  ) : (
    <div>{getLocalization('noPreview')}</div>
  );
}
